import axios from 'axios';
import Qs from 'qs';
import global from './global.js'

axios.defaults.withCredentials = true
// 创建axios实例
const service = axios.create({
    // http://www.jordinasrl.com/ewaimai
    // baseURL: process.env.NODE_ENV === 'development' ? '/jdwm' : 'http://139.224.237.111/jdwm', // api的base_url
    baseURL:
    window.global.remoteServer,
            //  : 'http://123.57.13.103:8081', // api的base_url
    timeout: 80000 // 请求超时时间
});

// request拦截器
service.interceptors.request.use(
    request => {
        request.transformRequest = [
            data => {
                return typeof data === 'object' &&
                    request.headers['Content-Type'] !== 'multipart/form-data'
                    ? Qs.stringify(data)
                    : data;
            }
        ];
        return request;
    },
    error => {
        return error;
    }
);

// respone拦截器
service.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        return error;
    }
);

export default service;



// WEBPACK FOOTER //
// ./src/api/http.js